module.exports = __webpack_public_path__ + "161a30b1d193366abab8f810db4ec6f5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/trumpet.png
// module id = 2631
// module chunks = 0